"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var gsap_1 = require("../../../src/js/libraries/gsap");
document.addEventListener('alpine:init', function () {
    Alpine.data('visualiser', function () {
        var styles = [
            {
                styleID: 'exterior_coastal',
                name: 'Coastal',
                image: { src: '/img/visualiser/exterior_coastal.jpg', alt: 'Alt text' },
                isExterior: true,
            },
            {
                styleID: 'interior_coastal',
                name: 'Coastal',
                image: { src: '/img/visualiser/interior_coastal.jpg', alt: 'Alt text' },
                isExterior: false,
            },
            {
                styleID: 'exterior_contemporary',
                name: 'Contemporary',
                image: { src: '/img/visualiser/exterior_contemporary.jpg', alt: 'Alt text' },
                isExterior: true,
            },
            {
                styleID: 'interior_contemporary',
                name: 'Contemporary',
                image: { src: '/img/visualiser/interior_contemporary.jpg', alt: 'Alt text' },
                isExterior: false,
            },
            {
                styleID: 'exterior_farmhouse',
                name: 'Farmhouse',
                image: { src: '/img/visualiser/exterior_farmhouse.jpg', alt: 'Alt text' },
                isExterior: true,
            },
            {
                styleID: 'interior_farmhouse',
                name: 'Farmhouse',
                image: { src: '/img/visualiser/interior_farmhouse.jpg', alt: 'Alt text' },
                isExterior: false,
            },
            {
                styleID: 'exterior_hamptons',
                name: 'Hamptons',
                image: { src: '/img/visualiser/exterior_hamptons.jpg', alt: 'Alt text' },
                isExterior: true,
            },
            {
                styleID: 'interior_hamptons',
                name: 'Hamptons',
                image: { src: '/img/visualiser/interior_hamptons.jpg', alt: 'Alt text' },
                isExterior: false,
            },
            {
                styleID: 'exterior_palm-springs',
                name: 'Palm Springs',
                image: { src: '/img/visualiser/exterior_palm-springs.jpg', alt: 'Alt text' },
                isExterior: true,
            },
            {
                styleID: 'interior_palm-springs',
                name: 'Palm Springs',
                image: { src: '/img/visualiser/interior_palm-springs.jpg', alt: 'Alt text' },
                isExterior: false,
            },
        ];
        return {
            mode: null,
            styles: [],
            products: [],
            selectedStyleID: '',
            selectedProductID: '',
            currentlyViewingPanelOpen: false,
            currentlyViewingDetailsOpen: false,
            stylesPanelOpen: false,
            productsPanelOpen: false,
            enableStyleSelection: true,
            init: function () {
                if (typeof window.visualiserData === 'undefined') {
                    throw new Error('Could not initialise Visualiser. Required data not found.');
                }
                /**
                 * A script tag within this module creates a global variable `visualiserData` where it
                 * contains the data needed for the visualiser to function.
                 * Read that data and assign it to our Alpine component so that it's reactive.
                 */
                this.products = window.visualiserData.products;
                this.selectedProductID = window.visualiserData.selectedProductID || this.products[0].productID;
                // Set the mode based on the selcted product.
                this.updateMode(this.selectedProductID);
                this.selectedStyleID = "".concat(this.mode, "_").concat(window.visualiserData.selectedStyleID);
                var enabledStyles = [];
                // Only keep enabled styles.
                styles.forEach(function (style) {
                    window.visualiserData.styles.forEach(function (partialStyleID) {
                        // E.g. The syntax is either interior_hamptons or exterior_hamptons, so we check the string ends with 'hamptons'.
                        if (style.styleID.endsWith(partialStyleID)) {
                            enabledStyles.push(style);
                        }
                    });
                });
                this.styles = enabledStyles;
                this.enableStyleSelection = window.visualiserData.styles.length > 1;
            },
            /**
             * Updates mode based on the selected product.
             * @param productID
             */
            updateMode: function (productID) {
                var p = this.getProduct(productID);
                this.mode = p.isExterior ? 'exterior' : 'interior';
            },
            /**
             * Retrieves style object based on StyleID.
             * @param styleID
             */
            getStyle: function (styleID) {
                return this.styles.find(function (style) { return style.styleID === styleID; });
            },
            /**
             * Sets the current style based on styleID.
             * @param styleID string
             * @param autoClose boolean
             */
            setStyle: function (styleID, autoClose) {
                if (autoClose === void 0) { autoClose = false; }
                this.selectedStyleID = styleID;
                this.bringStyleIntoView();
                if (!this.$store.app.md && autoClose) {
                    this.toggleStylePanel(false);
                }
                this.$store.app.track({
                    event: 'visualiser',
                    type: 'click',
                    trigger: 'change-home',
                    module: 'visualiser',
                    data: {
                        style_id: this.selectedStyleID,
                    },
                });
            },
            /**
             * Filters styles by the current mode.
             */
            getStylesByMode: function () {
                var _this = this;
                return this.styles.filter(function (style) {
                    return style.isExterior === (_this.mode === 'exterior');
                });
            },
            /**
             * Returns the the currently selected style.
             */
            getSelectedStyle: function (name) {
                if (name === void 0) { name = false; }
                var style = this.getStyle(this.selectedStyleID);
                if (name === true) {
                    return style.styleID.split('_')[1];
                }
                return style;
            },
            /**
             * Returns a product by productID.
             * @param productID
             */
            getProduct: function (productID) {
                return this.products.find(function (product) { return product.productID === productID; });
            },
            /**
             * Sets the current product based on productID.
             * @param productID
             * @param $el
             */
            setProduct: function (productID, $el) {
                var _this = this;
                this.selectedProductID = productID;
                // Update the mode and style based on the current selected product.
                this.updateMode(productID);
                this.setStyle("".concat(this.mode, "_").concat(this.getSelectedStyle(true)));
                this.bringProductIntoView($el);
                this.$nextTick(function () {
                    if (!_this.$store.app.md) {
                        _this.toggleProductPanel(false);
                    }
                });
                this.$store.app.track({
                    event: 'visualiser',
                    type: 'click',
                    trigger: 'change-door',
                    module: 'visualiser',
                    data: {
                        product_id: this.selectedProductID,
                    },
                });
            },
            /**
             * Returns the currently selected product.
             */
            getSelectedProduct: function () {
                return this.getProduct(this.selectedProductID);
            },
            /**
             * Toggles the 'Currently viewing' panel.
             * @param force
             */
            toggleCurrentlyViewingPanel: function (force) {
                if (typeof force === 'undefined') {
                    this.currentlyViewingPanelOpen = !this.currentlyViewingPanelOpen;
                }
                else {
                    this.currentlyViewingPanelOpen = force;
                }
            },
            /**
             * Scrolls the selected product into view within the Products Panel.
             * @param el
             */
            bringProductIntoView: function (el) {
                var _this = this;
                var offset = this.$store.app.md ? 100 : 0;
                setTimeout(function () {
                    (0, gsap_1.scrollVertically)(_this.$refs.productsPanel, el, offset, 0.5);
                }, 50);
            },
            /**
             * Scrolls the selected style into view within the Styles Panel.
             */
            bringStyleIntoView: function () {
                var _this = this;
                var offset = this.$store.app.md ? 100 : 0;
                setTimeout(function () {
                    var activeStyle = _this.$refs.stylesPanel.querySelector('.active-style');
                    if (activeStyle) {
                        (0, gsap_1.scrollVertically)(_this.$refs.stylesPanel, activeStyle, offset, 0.5);
                    }
                }, 50);
            },
            /**
             * Toggles the Product Panel's visibility.
             * @param force optional boolean to force the state to on or off.
             */
            toggleProductPanel: function (force) {
                if (typeof force === 'undefined') {
                    this.productsPanelOpen = !this.productsPanelOpen;
                }
                else {
                    this.productsPanelOpen = force;
                }
            },
            /**
             * Toggles the Style Panel's visibility.
             * @param force optional boolean to force the state to on or off.
             */
            toggleStylePanel: function (force) {
                if (typeof force === 'undefined') {
                    this.stylesPanelOpen = !this.stylesPanelOpen;
                }
                else {
                    this.stylesPanelOpen = force;
                }
                if (this.stylesPanelOpen === true) {
                    this.bringStyleIntoView();
                }
            },
            /**
             * Closes all panels.
             */
            closeAllPanels: function () {
                this.toggleProductPanel(false);
                this.toggleStylePanel(false);
            },
            /**
             * Runs through product attributes and renders its value based on the type of data.
             * @param value
             */
            renderAttributeValue: function (value) {
                var values = [];
                if (Array.isArray(value)) {
                    value.forEach(function (item) {
                        if (typeof item === 'string') {
                            values.push(item);
                        }
                        else {
                            if (typeof item.title === 'string') {
                                values.push(item.title);
                            }
                        }
                    });
                }
                else {
                    values.push(value);
                }
                return values.join(', ');
            },
        };
    });
});
